import type { State } from '../../types';
import type { ReportViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function reportsNotDeleted(state: State): ReportViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.reportsById).filter((e) => !e.deleted);
}
